/*
    Bard levert een <table> zonder omhulsel. Zonder wrapper is er geen element om
    het scrollen op te hangen en duwt een brede tabel de hele pagina horizontaal
    open op een telefoon.

    Stond eerst als privéfunctie in article-enhancements.js en gold daardoor
    alleen voor blogartikelen. Bard-content staat ook in de gewone contentkolom
    van pagina's (.main-content), dus die tabellen hadden hetzelfde nodig.

    Progressive enhancement: zonder JS blijft de tabel leesbaar, alleen zonder
    eigen scrollgebied.

    Blokken die hun eigen scrollwrapper meebrengen (blocks/_price_table.antlers.html)
    markeren die met data-table-wrapped. Zonder die uitzondering komt er een tweede
    wrapper om de tabel en tellen de marges van beide wrappers bij elkaar op.
*/

const WRAP_CLASS = 'content-table-wrap';

export default function wrapTables (selector) {
    document.querySelectorAll(selector).forEach(table => {
        if ( table.parentElement?.classList.contains(WRAP_CLASS) ) return;
        if ( table.closest('[data-table-wrapped]') ) return;

        const wrap = document.createElement('div');
        wrap.className = WRAP_CLASS;
        // Scrollbare gebieden moeten met het toetsenbord bereikbaar zijn.
        wrap.tabIndex = 0;
        wrap.setAttribute('role', 'region');
        wrap.setAttribute('aria-label', 'Tabel, horizontaal scrollbaar');

        table.replaceWith(wrap);
        wrap.append(table);
    });
}
